angular
    .module('empower.control')
    .directive("resize", ['$rootScope', '$window', function ($rootScope, $window) {
        return function (scope) {

            $rootScope.pageWidth = $window.innerWidth;
            $rootScope.pageHeight = $("#page-container").innerHeight();

            angular.element($window).bind('resize', function () {
                scope.$apply(function () {
                    //console.log("page width, height "+$window.innerWidth+" "+$("#page-container").innerHeight());
                    //console.log("page width "+$window.innerWidth);
                    $rootScope.pageWidth = $window.innerWidth;
                    $rootScope.pageHeight = $("#page-container").innerHeight();
                    $(".popup").css("height", $rootScope.pageHeight + "px");
                    //var perc = window.pageYOffset / $rootScope.pageHeight * 100;
                    //perc = perc + 15;
                    //var fromTop = $rootScope.deviceType === false ? Number($rootScope.pageHeight * perc / 100) : window.pageYOffset + 20;
                    //$(".popup-box").css({ top: fromTop + "px" });
                    /*$rootScope.isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());*/
                });
            });
        };

    }]);
